<template>
  <v-card v-bind="$attrs">
    <v-card-title style="font-size: 15px" class="grey--text text--darken-2">
      <v-icon v-if="!imageMode" left>mdi-paperclip</v-icon>
      <v-icon v-else left>mdi-image-multiple</v-icon>
      {{ title }}
      <v-spacer></v-spacer>
      <span class="caption" :class="{ 'red--text': count > countLimit }">
        {{ count }}/{{ countLimit }}
      </span>
    </v-card-title>
    <v-card-text>
      <input
        @change="handleFileChange"
        type="file"
        ref="file"
        v-show="false"
        :multiple="countLimit - count > 1"
        :accept="accept"
      />
      <div v-if="files.length > 0">
        <v-row dense>
          <v-col v-for="file in files" :key="file.id" cols="12" sm="6">
            <FileChip
              :file="file"
              @click:remove="handleClickRemove(file)"
              :imageMode="imageMode"
            >
            </FileChip>
          </v-col>
        </v-row>
      </div>
      <div v-if="uploads.length > 0">
        <FileChip
          v-for="upload in uploads"
          :key="upload.id"
          :imageMode="imageMode"
        ></FileChip>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="handleClickUpload()"
        color="primary"
        class="text-capitalize pr-4"
        elevation="0"
        :disabled="count >= countLimit"
      >
        <v-icon left>mdi-plus</v-icon> Adicionar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FileChip from "./FileChip.vue";
import { upload, removeFile } from "@/services/simple_fnol";

export default {
  mixins: [],

  components: {
    FileChip,
  },

  props: {
    title: String,
    files: Array,
    fileType: String,
    countLimit: {
      type: Number,
      default: 1,
    },
    imageMode: Boolean,
  },

  data() {
    return {
      nextId: 1,
      uploads: 0,
    };
  },

  methods: {
    handleClickUpload() {
      this.$refs.file.click();
    },
    async handleFileChange(event) {
      const files = Array.from(event.target.files).slice(
        0,
        this.countLimit - this.count
      );

      this.uploads += files.length;

      for await (const file of files) {
        try {
          const response = await upload(
            this.$route.params.token,
            file,
            this.fileType
          );
          this.$emit("uploaded", response.data);
        } catch (error) {
          console.error(error);
        } finally {
          this.uploads--;
        }
      }

      this.$refs.file.value = null;
    },
    async handleClickRemove(file) {
      this.$emit("removed", file);

      try {
        await removeFile(this.$route.params.token, file.id);
      } catch (error) {
        this.$emit("uploaded", file);
      }
    },
  },

  computed: {
    count() {
      return this.files.length;
    },
    accept() {
      if (this.imageMode) {
        return "image/png, image/jpeg";
      }

      return "image/png, image/jpeg, application/pdf, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.spreadsheet";
    },
  },
};
</script>

<style lang="scss" scoped>
.chips-container {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
</style>
